// modules
import LoadingStore from './store';

class LoadingService extends LoadingStore {}

export default new LoadingService();
